import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { removeCartVoucherItem } from '../../../actions/action_cart_voucher_items';
import formatUSD from '../../../utils/formatUSD';

const VoucherContainer = styled.li`
  display: block;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 36px;
  list-style: none;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;

const VoucherItemsWrapper = styled.div`
  padding: 0 16px;
`;

const SectionHeader = styled.h5`
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 16px 0;
  color: #333;
`;

const VoucherItem = styled.div`
  display: block;
  padding: 36px 0;
  border-bottom: ${(props) => (props.isLastItem ? 'none' : '1px solid #ddd')};

  &:first-of-type {
    padding-top: 0;
  }
`;

const LeftColumn = styled.div`
  padding: 0;
`;

const RightColumn = styled.div`
  padding: 0;
  text-align: right;
`;

const VoucherName = styled.div`
  font-weight: 900;
  width: 100%;
`;

const VoucherUnitPrice = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: normal;
  padding-bottom: 16px;
`;

const TotalToSpend = styled.span`
  display: inline-block;
  font-size: 14px;
  color: #166534;
  font-weight: 600;
  background-color: #ecfdf5;
  padding: 4px 8px;
  border-radius: 4px;
`;

const TotalToSpendWrapper = styled.div`
  margin-bottom: 12px;
`;

const VoucherImage = styled.img`
  display: block;
  width: 100%;
  max-width: 200px;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  margin-bottom: 12px;
`;

const VoucherQuantity = styled.div`
  font-size: 14px;
  color: #666;
`;

const VoucherTotalPrice = styled.div`
  font-weight: 900;
`;

const RemoveLink = styled.a`
  color: #479de6;
  display: block;
  padding-top: 4px;
  cursor: pointer;
  &:hover {
    color: #479de6;
  }
`;

const CartVoucherItems = ({ items }) => {
  const dispatch = useDispatch();
  const cartUuid = useSelector((state) => state.v3Order?.uuid);
  const protectedCheckout = useSelector(
    (state) =>
      state.v3Order?.retouchingCheckoutProtected ||
      state.v3Order?.retouchingCheckoutRequest,
  );

  if (!items || items.length === 0) {
    return null;
  }

  const handleRemove = (itemId) => {
    if (cartUuid && !protectedCheckout) {
      dispatch(removeCartVoucherItem(cartUuid, itemId));
    }
  };

  return (
    <VoucherContainer>
      <SectionHeader>Vouchers</SectionHeader>
      <VoucherItemsWrapper>
        {items.map((item, index) => {
          const voucherProduct = item.voucher_product || {};
          const name = voucherProduct.name || item.name || 'Voucher';
          const imageUrl = voucherProduct.image_thumbnail || item.image_url;
          const unitPriceCents =
            voucherProduct.purchase_price_cents ??
            item.unit_price_cents ??
            item.subtotal_cents / item.quantity;

          return (
            <VoucherItem
              key={`voucher-item-${item.id}`}
              isLastItem={index === items.length - 1}
              className="row"
            >
              <LeftColumn className="col-xs-9">
                <VoucherName>{name}</VoucherName>
                <VoucherUnitPrice>{formatUSD(unitPriceCents)}</VoucherUnitPrice>
                {voucherProduct.total_value_cents && (
                  <TotalToSpendWrapper>
                    <TotalToSpend>
                      Total to Spend:{' '}
                      {formatUSD(voucherProduct.total_value_cents)}
                    </TotalToSpend>
                  </TotalToSpendWrapper>
                )}
                {imageUrl && <VoucherImage src={imageUrl} alt={name} />}
                <VoucherQuantity>Qty: {item.quantity}</VoucherQuantity>
              </LeftColumn>
              <RightColumn className="col-xs-3 text-right">
                <VoucherTotalPrice>
                  {formatUSD(item.subtotal_cents)}
                </VoucherTotalPrice>
                {!protectedCheckout && (
                  <RemoveLink onClick={() => handleRemove(item.id)}>
                    Remove
                  </RemoveLink>
                )}
              </RightColumn>
            </VoucherItem>
          );
        })}
      </VoucherItemsWrapper>
    </VoucherContainer>
  );
};

export default CartVoucherItems;
